import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function StickyNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToGallery = () => {
    if (location.pathname === '/') {
      const el = document.querySelector('.main-content');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <Box
      component="nav"
      aria-label="Navigation principale"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 52,
        bgcolor: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 1px 8px rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        px: { xs: 2, sm: 4 },
        zIndex: 1100,
      }}
    >
      <Box
        onClick={() => navigate('/')}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.25, cursor: 'pointer', flex: 1, userSelect: 'none' }}
      >
        <Box
          component="img"
          src="/logo.svg"
          alt="Noëlle Boronad"
          sx={{ height: 34, width: 34, flexShrink: 0 }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: '0.82rem', sm: '0.95rem' },
            color: 'primary.main',
            letterSpacing: '-0.01em',
            whiteSpace: 'nowrap',
          }}
        >
          Noëlle Boronad
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: { xs: 0.25, sm: 1 }, alignItems: 'center' }}>
        <Button
          size="small"
          onClick={scrollToGallery}
          sx={{ color: 'text.secondary', fontWeight: 500, fontSize: { xs: '0.72rem', sm: '0.82rem' }, px: { xs: 1, sm: 1.5 }, minWidth: 0 }}
        >
          Galerie
        </Button>
        <Button
          size="small"
          onClick={() => navigate('/biographie')}
          sx={{ color: 'text.secondary', fontWeight: 500, fontSize: { xs: '0.72rem', sm: '0.82rem' }, px: { xs: 1, sm: 1.5 }, minWidth: 0, display: { xs: 'none', sm: 'inline-flex' } }}
        >
          Biographie
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => navigate('/contact-artist')}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            fontSize: { xs: '0.72rem', sm: '0.82rem' },
            px: { xs: 1.25, sm: 2 },
            minWidth: 0,
            bgcolor: '#1a1a1a',
            boxShadow: 'none',
            '&:hover': { bgcolor: '#333333', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' },
          }}
        >
          Contact
        </Button>
      </Box>
    </Box>
  );
}
